const fonts = {
	welcomeScreenMainHeadingFontSize: '2rem',
	headerHeadingFontSize: '1.25rem',
	mainHeadingFontSize: '1.6rem',
	subHeadingFontSize: '1.4rem',
	mainHeadingFontSize1: '2.6rem',
	subHeadingFontSize1: '2rem',
	buttonFontSize: '1.4rem',

	errorHeadingFontSize: '0.2rem',

	primaryFont: 'Poppins',

	mainHeadingfontFamilyClass: 'font-face-B',
	subHeadingfontFamilyClass: 'font-face-M',
};

export default fonts;
